import { render, staticRenderFns } from "./Commisions.vue?vue&type=template&id=a847312c"
import script from "./Commisions.vue?vue&type=script&lang=js"
export * from "./Commisions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports